// Giriş sayfası duyuru kartları (giriş ekranı + admin önizleme ortak)
import { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';
import { Info, BellRing, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ANN_TYPES = {
  info: { label: 'Bilgi', icon: Info, box: 'border-sky-200 bg-sky-50', head: 'text-sky-900', icon_c: 'text-sky-600' },
  reminder: { label: 'Hatırlatma', icon: BellRing, box: 'border-amber-200 bg-amber-50', head: 'text-amber-900', icon_c: 'text-amber-600' },
  important: { label: 'Önemli', icon: AlertTriangle, box: 'border-rose-200 bg-rose-50', head: 'text-rose-900', icon_c: 'text-rose-600' },
};

export const AnnouncementCard = ({ a, index = 0 }) => {
  const t = ANN_TYPES[a.type] || ANN_TYPES.info;
  const Icon = t.icon;
  return (
    <div className={`rounded-xl border p-4 shadow-sm animate-in fade-in slide-in-from-bottom-2 ${t.box}`} style={{ animationDelay: `${index * 80}ms`, animationFillMode: 'both' }} data-testid={`login-announcement-${a.id || 'preview'}`}>
      <p className={`flex items-center gap-2 text-sm font-semibold ${t.head}`}><Icon className={`h-4 w-4 shrink-0 ${t.icon_c}`} />{a.title || t.label}</p>
      <div className="announcement-content mt-1.5 text-sm text-slate-700" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(a.html || '', { ADD_ATTR: ['target'] }) }} />
    </div>
  );
};

export const LoginAnnouncements = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/public/login-announcements`).then(r => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="w-full max-w-md space-y-3" data-testid="login-announcements">
      {items.map((a, i) => <AnnouncementCard key={a.id} a={a} index={i} />)}
    </div>
  );
};
